import { gate } from 'hub-http/gates';
export const gates = {
  CONVERSATIONAL_ENRICHMENT_BETA: gate('ConversationalEnrichment:EmailParser:Beta'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE: gate('ConversationalEnrichment:Model:EmploymentChange'),
  ENRICHMENT_AUTO_LAST_ENGAGEMENT_COMPANIES: gate('DataEnrichment:LastEngagementCompanies'),
  ENRICHMENT_AUTO_PAUSE: gate('DataEnrichment:AutoPause'),
  ENRICHMENT_SMART_PROPERTIES: gate('DataEnrichment:SmartProperties'),
  HUBSPOT_CREDITS: gate('HubSpotCredits'),
  ENRICHMENT_FREE_OPT_OUT: gate('DataEnrichment:FreeOptOut'),
  CONVERSATIONAL_ENRICHMENT_EMPLOYMENT_CHANGE_TOGGLE: gate('ConversationalEnrichment:FEToggle:EmploymentChange'),
  CONVERSATIONAL_ENRICHMENT_OUT_OF_OFFICE_TOGGLE: gate('ConversationalEnrichment:FEToggle:OutOfOffice')
};